import * as React from "react";
import { cn } from "../../lib/utils";

// The template's skeleton (next-shadcn-admin-dashboard/src/components/ui/
// skeleton.tsx at bff60d4), ported by hand. Two things are Helix's: the bar
// is hidden from screen readers (its container announces the loading state),
// and it stops pulsing under reduced motion, which the template's does not.
// Record: docs/testing/ui-migration/010-ui-skeleton.md.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      aria-hidden="true"
      className={cn("animate-pulse rounded-md bg-muted motion-reduce:animate-none", className)}
      {...props}
    />
  );
}

export { Skeleton };
